var exports = {
  "kL": "x112a1f60--18079c--container",
  "AS": "x112a1f60--18079c--item",
  "PS": "x112a1f60--18079c--house",
  "jB": "x112a1f60--18079c--newbuilding",
};

module.exports = exports;
